import * as React from "react";
import { TypographyBox } from "./style";
export default class Typography extends React.PureComponent {
    render() {
        const { content, bgColor, positionId } = this.props;
        return (React.createElement(TypographyBox, { id: positionId, color: bgColor || "#fff" },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: content } })));
    }
}
